/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component} from '@angular/core';

@Component({
  standalone: false,
  selector: 'app',
  template: '<ui-view></ui-view>'
})
export class AppComponent {
}
